import styled from 'styled-components'
import { Header, Icon as BRCIcon } from '@navinc/base-react-components'
import { Divider } from '../divider'

const StyledHeader = styled(Header)`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  display: grid; /* stylelint-disable-line declaration-block-no-duplicate-properties  */
  grid-template-columns: 1.5em 1fr;
  padding-bottom: 16px;

  & > :first-child {
    margin-right: 0.5em;
    color: ${({ theme }) => theme.navNeutralDark};
    flex-shrink: 0;
  }
`
export const CardHeader = styled(({ Icon, iconColor, children, ...props }) => (
  <div>
    <StyledHeader size="sm" {...props}>
      {Icon ? (
        typeof Icon === 'string' ? (
          <BRCIcon name={Icon} data-testid={`card-header-icon:${Icon}`} />
        ) : (
          <Icon />
        )
      ) : null}
      {children}
    </StyledHeader>
    <Divider />
  </div>
))``
